import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';

import { WhatToBring } from '../../shared/what-to-bring.model';
import { WhatToBringDetailComponent } from '../../what-to-bring-detail/what-to-bring-detail.component';

@Component({
  selector: 'app-what-to-bring-modal',
  templateUrl: './what-to-bring-modal.component.html',
  standalone: true,
  imports: [SharedModule, WhatToBringDetailComponent],
})
export class WhatToBringModalComponent {
  constructor(
    private ref: MatDialogRef<WhatToBringModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  // @Output() dialogSaved = new EventEmitter<any>(); // avoid closing the dialog

  modalTitle = this.data.title;
  whatToBring: WhatToBring = this.data.obj;
  mode = this.data.params.mode;
  defaultLanguage = this.data.params.defaultLanguage;
  additionalLanguages = this.data.params.additionalLanguages;

  // Referenced from app-whatToBring-detail
  onSavedWhatToBring(whatToBring) {
    // this.dialogSaved.emit(whatToBring); // avoid closing the dialog

    this.ref.close(whatToBring); // close the dialog
  }

  // Referenced from app-what-to-bring-detail
  onCanceledWhatToBring() {
    this.close();
  }

  close() {
    this.ref.close();
  }
}
